export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 700 250\"><rect rx=\"4\"/></svg>";


// WEBPACK FOOTER //
// webpack://ClassicEditor/ckeditor5-image/theme/icons/image_placeholder.svg